var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0908 6.5H5.09082C3.98625 6.5 3.09082 7.39543 3.09082 8.5V17.5C3.09082 18.6046 3.98625 19.5 5.09082 19.5H19.0908C20.1954 19.5 21.0908 18.6046 21.0908 17.5V8.5C21.0908 7.39543 20.1954 6.5 19.0908 6.5H14.0908M10.0908 6.5V5.5C10.0908 4.39543 10.9863 3.5 12.0908 3.5C13.1954 3.5 14.0908 4.39543 14.0908 5.5V6.5M10.0908 6.5C10.0908 7.60457 10.9863 8.5 12.0908 8.5C13.1954 8.5 14.0908 7.60457 14.0908 6.5M9.09082 14.5C10.1954 14.5 11.0908 13.6046 11.0908 12.5C11.0908 11.3954 10.1954 10.5 9.09082 10.5C7.98625 10.5 7.09082 11.3954 7.09082 12.5C7.09082 13.6046 7.98625 14.5 9.09082 14.5ZM9.09082 14.5C10.397 14.5 11.5082 15.3348 11.9201 16.5M9.09082 14.5C7.7846 14.5 6.67331 15.3348 6.26147 16.5M15.0908 11.5H18.0908M15.0908 15.5H17.0908",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentification);
export default __webpack_public_path__ + "static/media/identification.2d91f17cb606f3adfd6dff693820faf4.svg";
export { ForwardRef as ReactComponent };